import { createSelector } from 'reselect'
import { getPageParams } from 'selectors/page'
import { getUserID } from 'selectors/user/session'
import { getAlgoliaQuery } from './algolia'
import { getCollectionIdUserCollection } from './collection'
import { getSelectedFacets } from './facets'
import { urlQuery } from '../helpers/url'
export const getCollectionId = createSelector(
  getPageParams,
  (params): string => params.collectionId || 0
)
export const getOwnerId = createSelector(getPageParams, (params): string => params.ownerId || '')
export const getTitle = createSelector(getPageParams, (params): string => params.title || '')
export const getUrlPathString = createSelector(
  [getCollectionId, getOwnerId, getTitle],
  (collectionId, ownerId, title): string =>
    `/art-collection/${title}/${ownerId}/${collectionId}/view`
)
export const getUrlQueryString = createSelector(
  [getSelectedFacets, getAlgoliaQuery],
  (selectedFacets, algoliaQueryParams): string =>
    urlQuery({ ...selectedFacets, ...algoliaQueryParams })
)
export const getUrlString = createSelector(
  [getUrlPathString, getUrlQueryString],
  (urlPathString, urlQueryString): string => `${urlPathString}${urlQueryString}`
)
export const getUrlStringWithParams = (params: Record<string, any>) =>
  createSelector(
    [getUrlPathString, getSelectedFacets, getAlgoliaQuery],
    (urlPathString, selectedFacets, algoliaQuery): string => {
      const queryParams = { ...selectedFacets, ...algoliaQuery, ...params }
      const queryString = urlQuery(queryParams)
      return `${urlPathString}${queryString}`
    }
  )
export const getUrlStringWithoutParams = (params: Record<string, any>) =>
  createSelector(
    [getUrlPathString, getSelectedFacets, getAlgoliaQuery],
    (urlPathString, selectedFacets, algoliaQuery): string => {
      const queryParams = { ...params }
      const queryString = urlQuery(queryParams)
      return `${urlPathString}${queryString}`
    }
  )
export const getUserCollectionsUrl = createSelector([getUserID], (userId): string => {
  return `/account/collection/${userId}`
})
export const getAdminUrlLinks = createSelector(
  [getCollectionId, getOwnerId, getCollectionIdUserCollection, getUserCollectionsUrl],
  (collectionId, ownerId, idUserCollection, collectionsUrl): Record<string, any> => ({
    createUrl: '/collections/create',
    deleteUrl: `/collections/delete/collection/${collectionId}/owner/${ownerId}`,
    duplicateUrl: `/collections/duplicate/${ownerId}/${collectionId}`,
    editUrl: `/collections/edit/owner/${ownerId}/collection/${collectionId}`,
    iosVirUrl: `/ios-redirect/vir/${idUserCollection} `,
    exportEmailsUrl: `/collections/get-collection-artist-emails/owner/${ownerId}/collection/${collectionId}`,
    reorderUrl: `/collections/reorder/owner/${ownerId}/collection/${collectionId}`,
    collectionsUrl,
  })
)